module.exports = function togglePrefClassYear() {
	var enablePrefClassYear = false;
	var enableRelationshipToStudent = true;

	var hiddenInput = window.jQuery('#personType_hidden');
	if (hiddenInput.length > 0) {
		enablePrefClassYear = hiddenInput.data('collectprefclassyear') === 1;
	} else {
		var selectedAffiliationTypes = window.jQuery('input[name=personType]:checked');
		selectedAffiliationTypes.each(function () {
			if (window.jQuery(this).data('collectclassyear') === true) {
				enablePrefClassYear = true;
			}
			if (window.jQuery(this).data('apialias') === 'isStudent') {
				// students can't have a relationship to themselves. see a therapist instead.
				enableRelationshipToStudent = false;
			}
		});
	}

	if (enablePrefClassYear) {
		window
			.jQuery('#preferredClassYear')
			.removeAttr('disabled')
			.attr('title', '')
			.removeAttr('rel')
			.closest('.expandable')
			.removeClass('hidden')
			.addClass('active');
	} else {
		window
			.jQuery('#preferredClassYear')
			.attr('disabled', 'disabled')
			.attr('title', 'Preferred Class Year only applies to alumni and students.')
			.attr('rel', 'tooltip')
			.closest('.expandable')
			.removeClass('active')
			.addClass('hidden');
	}

	if (enableRelationshipToStudent) {
		window.jQuery('#relationshipToStudentWrap').show();
		window.jQuery('#associatedStudent').show();
	} else {
		window.jQuery('#relationshipToStudentWrap').hide();
		window.jQuery('#associatedStudent').hide();
	}
};
